import { Button, Checkbox } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Config from "../../../Config";

import "./mrtt_client_screen.css";
import GeneralBloc from "../../../bloc/general_bloc";
import { ReactComponent as ProposalIcon } from "../../../Proposal2.svg";
import { ReactComponent as DeclarationIcon } from "../../../Declaration.svg";
import { ReactComponent as SignIcon } from "../../../Draft.svg";
import ProposalBloc from "../../../bloc/mrtt_proposal_bloc";
import AppModal from "../../component/app_modal/app_modal";
import AppMobileLoading from "../../dialog/app_mobile_loading";
import TermsAndConditionDialog from "../../component/terms_and_condition_dialog/terms_and_condition_dialog";

class ReviewDeclaration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            dialog: {
                open: false,
                type: "",
            },
            isASMB: false,
            acknowledgeFiles: {
                isImportantNoticRead: false,
                isTnCnDCIRead: false,
                isFATCAnCRSDeclareRead: false,
                isPersonalDataProtectionNoticeRead: false,
                isPersonToBeCoveredRead: false,
                isCustomerDeclareRead: false,

            },

            agreement: {
                personalInfo: false,
                shareContact: false,
                shareToThirdParties: false,
                agreeCollectData: false,
                readAndAgree: false
            }
        };
    }
    componentDidMount() {
        // Check if data is passed back from ReadDeclaration
        if (this?.props?.location?.state) {
            console.log("Location state:", this?.props?.location?.state);

            this.setState({
                agreement: {
                    personalInfo: this?.props?.location?.state?.agreement?.personalInfo,
                    shareContact: this?.props?.location?.state?.agreement?.shareContact,
                    shareToThirdParties: this?.props?.location?.state?.agreement?.shareToThirdParties,
                    // readAndAgree: this?.props?.location?.state?.agreement?.readAndAgree,
                    agreeCollectData: this?.props?.location?.state?.agreement?.agreeCollectData,
                    readAndAgree: this?.props?.location?.state?.agreement?.readAndAgree
                },
                acknowledgeFiles: {
                    isImportantNoticRead: this?.props?.location?.state?.acknowledgeFiles?.isImportantNoticRead,
                    isTnCnDCIRead: this?.props?.location?.state?.acknowledgeFiles?.isTnCnDCIRead,
                    isFATCAnCRSDeclareRead: this?.props?.location?.state?.acknowledgeFiles?.isFATCAnCRSDeclareRead,
                    isPersonalDataProtectionNoticeRead: this?.props?.location?.state?.acknowledgeFiles?.isPersonalDataProtectionNoticeRead,
                    isPersonToBeCoveredRead: this?.props?.location?.state?.acknowledgeFiles?.isPersonToBeCoveredRead,
                    isCustomerDeclareRead: this?.props?.location?.state?.acknowledgeFiles?.isCustomerDeclareRead,
                },
            });
        } else {
            this.initiateData();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // Check if acknowledgeFiles state has changed
        if (
            prevState.acknowledgeFiles !== this.state.acknowledgeFiles &&
            this.state.acknowledgeFiles.isPersonToBeCoveredRead &&
            (this.state.isASMB !== null ? this.state.isASMB === true ? this.state.acknowledgeFiles.isCustomerDeclareRead : true : false) &&
            // this.state.acknowledgeFiles?.isFATCAnCRSDeclareRead &&
            this.state.acknowledgeFiles?.isImportantNoticRead &&
            this.state.acknowledgeFiles?.isPersonalDataProtectionNoticeRead &&
            this.state.acknowledgeFiles?.isTnCnDCIRead
        ) {
            // Update agreement.readAndAgree only if not already true
            if (!this.state.agreement.readAndAgree) {
                this.setState({ agreement: { ...this.state.agreement, readAndAgree: true } });
            }
        }
    }

    getProposalId() {
        return this.props.match.params.itemId;
    }

    async initiateData() {
        this.setState({ loading: true })
        let result = await ProposalBloc.getFormDetailProposal(this.getProposalId(), Config.formProposalDetailMapping[10].category, 'client');
        let financialDetails = await ProposalBloc.getFormDetailProposal(this.getProposalId(), Config.formProposalDetailMapping[1].category, 'client');

        if (result.success) {
            this.handleAgreementChecked('personalInfo', this.filterDeclarationData(result.data[0]?.proposal_attr.properties?.answers, '1'))
            this.handleAgreementChecked('shareContact', this.filterDeclarationData(result.data[0]?.proposal_attr.properties?.answers, '2'))
            this.handleAgreementChecked('shareToThirdParties', this.filterDeclarationData(result.data[0]?.proposal_attr.properties?.answers, '3'))
            // this.handleAgreementChecked('readAndAgree', this.filterDeclarationData(result.data[0]?.proposal_attr.properties?.answers, '4'))
        }
        if (financialDetails) {
            this.setState({ isASMB: financialDetails?.financingInstitution === 'Alliance Bank Malaysia Berhad' || false });
        }
        this.setState({ loading: false })
    }

    filterDeclarationData(listing, id) {
        let filteredData = listing?.length > 0 ? listing.filter((item) => item.id == id)[0].status : 'No';
        return filteredData == 'Yes' ? true : false;
    }

    handleNextStep() {

    }

    handleValidateMandatoryField() {
        if (this.state.agreement.personalInfo && this.state.agreement.shareContact && this.state.agreement.shareToThirdParties && this.state.agreement.agreeCollectData && this.state.agreement.readAndAgree) {
            return false;
        } else {
            return true;
        }
    }

    handleAgreementChecked(key, val) {
        let agreementData = this.state.agreement;
        agreementData[key] = val;
        this.setState({ agreement: agreementData });
    }

    async handleSubmitForm() {
        this.setState({ loading: true });
        let formData = {
            answers: []
        };
        const { agreement } = this.state;

        Object.keys(agreement).map(function (key) {
            let consentData = {
                status: '',
                id: '',
                compulsory: 'No',
                title: '',
                desc: ''
            };
            if (key == 'personalInfo') {
                consentData.id = '1';
                consentData.status = agreement[key] == true ? 'Yes' : 'No';
                consentData.compulsory = 'Yes';
            } else if (key == 'shareContact') {
                consentData.id = '2';
                consentData.status = agreement[key] == true ? 'Yes' : 'No';
                consentData.compulsory = 'No';
            } else if (key == 'shareToThirdParties') {
                consentData.id = '3';
                consentData.status = agreement[key] == true ? 'Yes' : 'No';
                consentData.compulsory = 'No';
            }
            else if (key == 'readAndAgree') {
                consentData.id = '4';
                consentData.status = agreement[key] == true ? 'Yes' : 'No';
                consentData.compulsory = 'Yes';
            }
            formData.answers.push(consentData);
        })

        let result = await ProposalBloc.saveFormProposal(this.getProposalId(), 'THIRD_PARTY_CONSENT', formData, 'client');
        console.log(result)
        if (result.success) {
            window.location.replace(`/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/${Config.routes.generic.client_review_signature}/${this.getProposalId()}`)
        } else {
            this.setState({
                title: 'Notification',
                message: result.message,
                isOpen: true
            })
        }
        console.log("hshsh", result);
        this.setState({ loading: false });
    }

    handleGoNext() {
        this.handleSubmitForm();
    }

    handleGoBack() {
        this.props.history.push(
            `/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/${Config.routes.generic.client_review_proposal}/${this.getProposalId()}`
        );
    }

    handleViewDeclaration() {
        const path = `/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/${Config.routes.generic.client_review_read_declaration}/${this.getProposalId()}`;
        this.props.history.push({
            pathname: path,
            state: {
                agreement: {
                    personalInfo: this.state?.agreement?.personalInfo,
                    shareContact: this.state?.agreement?.shareContact,
                    shareToThirdParties: this.state?.agreement?.shareToThirdParties,
                    // readAndAgree: this?.state?.agreement?.readAndAgree,
                    agreeCollectData: this.state?.agreement?.agreeCollectData,
                    readAndAgree: this.state?.agreement?.readAndAgree
                },
                acknowledgeFiles: {
                    isImportantNoticRead: this.state.acknowledgeFiles?.isImportantNoticRead,
                    isTnCnDCIRead: this.state.acknowledgeFiles?.isTnCnDCIRead,
                    isFATCAnCRSDeclareRead: this.state.acknowledgeFiles?.isFATCAnCRSDeclareRead,
                    isPersonalDataProtectionNoticeRead: this.state.acknowledgeFiles?.isPersonalDataProtectionNoticeRead,
                    isPersonToBeCoveredRead: this.state.acknowledgeFiles?.isPersonToBeCoveredRead,
                    isCustomerDeclareRead: this.state.acknowledgeFiles?.isCustomerDeclareRead,

                },
            },
        });
    }
    showMessageModal = () => {
        return (
            <AppModal
                open={this.state.isOpen}
                handleModalClose={() => this.setState({ isOpen: false })}
                // width={'50%'}
                title={this.state.title}
                subtitle={this.state.message}
                positiveButtonText={'Close'}
                handlePositivePress={() => this.setState({ isOpen: false })}
                closable={false}
            />
        )
    }

    loadingContent() {
        return (
            <div style={{ height: "100%" }}>
                <AppMobileLoading isLoading={this.state.loading} />
            </div>
        );
    }

    stepHeader() {
        return (
            <>
                <div className="column d-flex align-items-center justify-content-center">
                    <div className="d-flex row pr-2">
                        <div className="align-items-center justify-content-center" style={{ textAlign: '-webkit-center' }}>
                            <div className="process_step">
                                <ProposalIcon fill={'#FFFFFF'} style={{ height: 24, width: 24 }} />
                            </div>
                            <div className="">Proposal</div>
                        </div>

                    </div>
                    <div className="line_through_complete" ></div>
                    <div className="d-flex row pr-2">
                        <div className="align-items-center justify-content-center" style={{ textAlign: '-webkit-center' }}>
                            <div className="process_step">
                                <DeclarationIcon fill={'#FFFFFF'} style={{ height: 24, width: 24 }} />
                            </div>
                            <div className="">Declaration</div>
                        </div>

                    </div>
                    <div className="line_through_process"></div>
                    <div className="d-flex row p-2">
                        <div className="align-items-center justify-content-center" style={{ textAlign: '-webkit-center' }}>
                            <div className="pending_step">
                                <SignIcon fill={'#9599B6'} style={{ height: 24, width: 24 }} />
                            </div>
                            <div className="">Signature</div>
                        </div>

                    </div>
                </div>
            </>
        )
    }

    renderBottomBar() {
        return (
            <div className="bottom_container d-flex justify-content-center">
                <Button
                    disabled={this.handleValidateMandatoryField()}
                    style={{
                        backgroundColor: '#183028',
                        color: 'white',
                        width: '100%',
                        height: 49,
                        opacity: this.handleValidateMandatoryField() ? 0.7 : 1
                    }}
                    onClick={() => this.handleGoNext()}
                >
                    Next
                </Button>
            </div>
        )
    }

    handleScroll = (e) => {
        const bottom = Math.abs(e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop) < 1;

        if (bottom) {
            if (this.state.dialog.type == 'customerDeclaration')
                this.setState({ acknowledgeFiles: { ...this.state.acknowledgeFiles, isCustomerDeclareRead: true } })
            else if (this.state.dialog.type == 'importantNotes') {
                this.setState({ acknowledgeFiles: { ...this.state.acknowledgeFiles, isImportantNoticRead: true } })
            } else if (this.state.dialog.type == 'termsAndConditions') {
                this.setState({ acknowledgeFiles: { ...this.state.acknowledgeFiles, isTnCnDCIRead: true } })
            } else if (this.state.dialog.type == 'fatcaAndCrs') {
                this.setState({ acknowledgeFiles: { ...this.state.acknowledgeFiles, isFATCAnCRSDeclareRead: true } })
            } else if (this.state.dialog.type == 'personToBeCovered') {
                this.setState({ acknowledgeFiles: { ...this.state.acknowledgeFiles, isPersonToBeCoveredRead: true } })
            } else if (this.state.dialog.type == 'personalDataProtection') {
                this.setState({ acknowledgeFiles: { ...this.state.acknowledgeFiles, isPersonalDataProtectionNoticeRead: true } })
            }
        }
    }

    renderDialogContent() {
        if (this.state.dialog.type == 'importantNotes') {
            return <div className="mt-4 px-3" style={{ height: '30vh', overflowY: 'scroll', scrollbarColor: '#EE7623' }} onScroll={(e) => this.handleScroll(e)} key={'important-notes'} ref={this.containerRef} >
                <div className="mt-3" style={{ height: '40vh' }}>
                    Pursuant to Paragraph 5 of Schedule 9 to the Islamic Financial Services Act 2013 (“IFSA”), you are required to answer fully and accurately or correctly with reasonable care not to make any misrepresentation when answering any questions asked by FWD Takaful Berhad (“FWD Takaful”). It is your duty to disclose fully and correctly matters that you know to be relevant to the decision of FWD Takaful in accepting the risk, and determining the rates and terms to be applied; otherwise it may result in voidance of the Takaful contract, refusal of claims or change of terms. This duty of disclosure shall continue until the time the Takaful contract is entered into, varied or renewed. This is a common application form and you are at liberty to participate or not to participate in any of the several products offered by this application form. If you do not understand your obligations as stated above or if you need further explanation, please contact FWD Takaful or our intermediaries.
                    The issuance of Takaful Certificates for standard cases is within one month from the date of receipt of the application form, together with the complete documents/requirements and the appropriate Takaful Contribution. Proof of age is required prior to the payment of Takaful benefits under this Certificate.
                </div>
            </div>
        } else if (this.state.dialog.type == 'termsAndConditions') {
            return <div className="mt-4 px-3" style={{ height: '30vh', overflowY: 'scroll', scrollbarColor: '#EE7623' }} onScroll={(e) => this.handleScroll(e)} key={'terms-and-conditions'} ref={this.containerRef} >
                <div className="mt-3" style={{ height: '40vh' }}>
                    <div>
                        In consideration of FWD Takaful's agreement to accept my authorisation to debit my Credit/Debit Card to pay the Takaful Contribution(s) under the given Takaful Certificate number(s), I expressly agree to the following terms and conditions:
                        <ol style={{ textAlign: 'justify' }}>
                            <li className="mt-3">
                                FWD Takaful shall determine to make the debit at initial and regular intervals within a month and shall not be held responsible for any claims, losses, damages and expenses arising from the successful or the unsuccessful processing of the debit as authorised due to exceeding credit limit, system malfunction, power failure and/or all other factors beyond FWD Takaful’s control.
                            </li>
                            <li className="mt-3">
                                I shall resolve any problem or dispute arising from the processing of the debit with my Credit/Debit Card issuing bank as FWD Takaful is only responsible for arranging to debit my Credit/Debit Card account through the card centre as per my authorisation.
                            </li>
                            <li className="mt-3">
                                In the event the Takaful Contribution(s) amount deducted is/are insufficient, I hereby authorise FWD Takaful to deduct the remaining amount of my Takaful Contribution(s) as specified in the Application. All paid Takaful Contribution(s) will be held under the Application until the Takaful Certificate commences, with no profit payable to me.
                            </li>
                            <li className="mt-3">
                                I will ensure that FWD Takaful is notified in writing regarding any changes, loss, conversion or replacement of my Credit/Debit Card or cancellation of this authorisation at least one month before the next Takaful Contribution(s) is/are due, which shall only become effective after FWD Takaful has duly acknowledged receipt of my notifications.
                            </li>
                            <li className="mt-3">
                                I hereby agree to keep FWD Takaful indemnified against any claims, loss, damage and expenses which FWD Takaful may suffer arising from my authorisation to debit my Credit/Debit Card account as aforesaid.
                            </li>
                            <li className="mt-3">
                                Payable Takaful Contribution(s) payments will be considered as paid only upon successful processing of the debit by the card centre, and the actual receipt of the full Takaful Contribution(s) payment by FWD Takaful. The Takaful coverage shall only commence from the date of approval of the Application subject to full payment of the Takaful Contribution(s).
                            </li>
                            <li className="mt-3">
                                FWD Takaful to use this Credit/Debit Card account only for Takaful Contribution(s) refund and no other types of payment due to me, unless FWD Takaful receives a written instruction from the Payee to revoke this instruction and the Payee provides the Direct Credit details which must be approved by FWD Takaful prior to the Takaful Contribution(s) refund effective date.
                            </li>
                            <li className="mt-3">
                                I understand that all or part of the Takaful Contribution(s), charges and payments for this Application may be subjected to the prevailing government tax rate (if applicable), which must be paid.
                            </li>
                            <li className="mt-3">
                                Within a reasonable period, FWD Takaful shall provide a written notice:
                                <ol type="a">
                                    <li className="mt-3">
                                        To discontinue, interrupt, withdraw or suspend this service as it deems fit and FWD Takaful is not to be held liable for any loss or damage which may be suffered by me as a result of such action by FWD Takaful.
                                    </li>
                                    <li className="mt-3">
                                        To add, delete or amend any of the above terms and conditions from time to time. Such amendments shall become effective on such date as FWD Takaful may elect to adopt and the continued use of this service by me shall constitute my acceptance of the said amendments.
                                    </li>
                                    <li className="mt-3">
                                        To hold monies pursuant to the Takaful Contribution(s) refund due to the Payee in the event the information provided above is incorrect, incomplete and/or otherwise not possible due to no fault of FWD Takaful to successfully process this request until the new Direct Credit detail is received from me.
                                    </li>
                                </ol>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        } else if (this.state.dialog.type == 'fatcaAndCrs') {
            return <div className="mt-4 px-3" style={{ height: '30vh', overflowY: 'scroll', scrollbarColor: '#EE7623' }} onScroll={(e) => this.handleScroll(e)} key={'fatca-and-crs'} ref={this.containerRef} >
                <div className="mt-3" style={{ height: '40vh' }}>
                    In this regard, I declare and confirm the following:
                    <div className="p-2" >
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                        Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                        Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Sed
                        ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam,
                        eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.
                        Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
                        Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et
                        dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam,
                        nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur,
                        vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?
                    </div>
                </div>
            </div>
        } else if (this.state.dialog.type == 'personalDataProtection') {
            return <div className="mt-4 px-3" style={{ height: '30vh', overflowY: 'scroll', scrollbarColor: '#EE7623' }} onScroll={(e) => this.handleScroll(e)} key={'personal-data-protection'} ref={this.containerRef} >
                <div className="mt-3" style={{ height: '40vh', textAlign: 'justify' }}>
                    <ol>
                        <li className="mb-3">I/We understand and agree that any personal information collected or held by FWD Takaful (whether contained in this application form or otherwise obtained) may be used, processed, disclosed and shared by FWD Takaful with individuals/organisations related to and associated with FWD Takaful or any selected third party (within or outside of Malaysia, including retakaful and claims investigation companies and industry associations/federations) for the purpose of processing this application form and providing subsequent services for this and other financial products and services and to communicate with me/us for said purposes.</li>
                        <li className="mb-3">I/We understand that I/we have a right to request access to my personal information held by FWD Takaful and to request correction of any incorrect personal information or the limitation of the processing of my personal information. I/We consent and hereby authorise FWD Takaful to charge a fee for processing and complying with such data access requests or correction requests.</li>
                        <li className="mb-3">I/We further agree that a photocopy of this authorisation will be as effective and valid as the original.</li>
                        <li className="mb-3">
                            If you would like to receive information regarding any exclusive promotions and offers from FWD Takaful or third parties, please provide your consent by ticking the box below:
                            <Checkbox
                                onChange={(e) => this.setState({ collectInformation: e.target.checked })}
                                checked={this.state.collectInformation}
                            >
                                I/We agree that any personal information collected or held by FWD Takaful (whether contained in this application form or otherwise obtained) may be used by FWD Takaful or disclosed by FWD Takaful to third parties for the purposes of direct marketing and to communicate with me/us for such purposes.
                            </Checkbox>
                        </li>
                        <li className="mb-3">By submitting this application, I/we confirm that I/we have read and agreed to the Personal Data Protection Notice set out in the hyperlink: <span className="consent_declaration_color_text" style={{ cursor: 'pointer' }} onClick={() => window.open('https://www.fwd.com.my/tkfl-personal-data-protection-notice/', '_blank')}>PDPA Notice</span>.</li>
                    </ol>
                </div>
            </div>
        } else if (this.state.dialog.type == 'personToBeCovered') {
            return <div className="mt-4 px-3" style={{ height: '30vh', overflowY: 'scroll', scrollbarColor: '#EE7623' }} onScroll={(e) => this.handleScroll(e)} key={'person-to-be-covered'} ref={this.containerRef} >
                <div className="mt-3" style={{ height: '40vh' }}>
                    In this regard, I declare and confirm the following:
                    <div className="p-2" >
                        I understand that the FWD Takaful Mortgage Reducing Term Takaful product (FWD MRTT) is separate from the home loan facility offered or provided by Alliance Bank Malaysia Berhad to me; and
                        <div className="pt-2">I have opted to participate in the FWD MRTT on an independent and voluntary basis.</div>
                    </div>
                </div>
            </div>
        } else if (this.state.dialog.type == 'customerDeclaration') {
            return <div className="mt-4 px-3" style={{ height: '30vh', overflowY: 'scroll', scrollbarColor: '#EE7623' }} onScroll={(e) => this.handleScroll(e)} key={'customer-declaration'} ref={this.containerRef} >
                <div className="mt-3" style={{ height: '40vh' }}>
                    In this regard, I declare and confirm the following:
                    <div className="p-2" >
                        I understand that the FWD Takaful Mortgage Reducing Term Takaful product (FWD MRTT) is separate from the home loan facility offered or provided by Alliance Bank Malaysia Berhad to me; and
                        <div className="pt-2">I have opted to participate in the FWD MRTT on an independent and voluntary basis.</div>
                    </div>
                </div>
            </div>
        }
    }

    renderDisabled() {
        if (this.state.dialog.type == 'customerDeclaration') {
            return this.state.acknowledgeFiles?.isCustomerDeclareRead;
        } else if (this.state.dialog.type == 'importantNotes') {
            return this.state.acknowledgeFiles?.isImportantNoticRead
        } else if (this.state.dialog.type == 'termsAndConditions') {
            return this.state.acknowledgeFiles?.isTnCnDCIRead
        } else if (this.state.dialog.type == 'fatcaAndCrs') {
            return this.state.acknowledgeFiles?.isFATCAnCRSDeclareRead
        } else if (this.state.dialog.type == 'personToBeCovered') {
            return this.state.acknowledgeFiles?.isPersonToBeCoveredRead
        } else if (this.state.dialog.type == 'personalDataProtection') {
            return this.state.acknowledgeFiles?.isPersonalDataProtectionNoticeRead
        }
    }

    render() {
        return (
            <div className="client_container" style={{ height: '100%' }}>
                {
                    this.state.loading && this.loadingContent()
                }
                <div className="mobile_container d-fkex justify-content-center" style={{ height: window.innerHeight, overflowY: 'scroll' }}>
                    <div className="client_header justify-content-between px-4">
                        <img
                            src={
                                GeneralBloc.getAssetsContextPath() +
                                `/assets/icons/Back.svg`
                            }
                            onClick={() => this.handleGoBack()}
                            alt="Documents"
                            className=""
                            style={{ width: 15, height: 15, cursor: 'pointer' }}
                        />
                        Review and Sign
                        <div></div>
                    </div>
                    {this.renderBottomBar()}
                    <div className="d-flex justify-content-center p-4 row w-100 m-0">
                        {this.stepHeader()}
                        <div className="mt-4">
                            <div className="client_instruction_header">
                                Please make sure you agree and consent to the following declarations before proceeding.
                            </div>
                            <div className="mt-5 client_instruction_text">
                                I hereby acknowledge that:
                                <div className="agreement_container">
                                    <Checkbox
                                        onChange={(e) => this.handleAgreementChecked('personalInfo', e.target.checked)}
                                        checked={this.state.agreement.personalInfo}
                                    >
                                        I agree to authorise FWD Takaful Berhad or FWD Takaful affiliates (this includes any entity within the FWD Takaful Group of Companies or Alliance Islamic Bank Group of Companies) to hold, use, disclose and share any personal information given to FWD Takaful or obtained by FWD Takaful now or at a later date with FWD Takaful affiliates for the purpose of processing this application and providing subsequent service for this and other financial products and services, direct marketing and data matching, and to communicate with me for such purpose. If I object to share this information with FWD Takaful affiliates for marketing, promotion and cross selling purposes, I will let FWD Takaful know in writing to FWD Takaful’s Customer Service.
                                    </Checkbox>
                                    <Checkbox
                                        onChange={(e) => this.handleAgreementChecked('shareContact', e.target.checked)}
                                        checked={this.state.agreement.shareContact}
                                    >
                                        I would like FWD Takaful to share my mailing and contact information with FWD Takaful’s other business partners who are not FWD Takaful’s affiliates so they can contact me to let me know of other products or services that FWD Takaful think I may be interested in or which FWD Takaful think may benefit me.
                                    </Checkbox>
                                    <Checkbox
                                        onChange={(e) => this.handleAgreementChecked('shareToThirdParties', e.target.checked)}
                                        checked={this.state.agreement.shareToThirdParties}
                                    >
                                        FWD Takaful may share my personal information with third parties, such as strategic alliances for marketing and promotional purposes. This consent given can be withdrawn at anytime by giving notice in writing to Customer Service.
                                    </Checkbox>
                                    <Checkbox
                                        // onChange={(e) => this.handleAgreementChecked('readAndAgree', e.target.checked)}
                                        checked={this.state.agreement.readAndAgree}
                                    >
                                        I confirm that I have read, acknowledged, and agree to the following:
                                        <br />
                                        <span style={{ color: "#92929D", paddingTop: "15px" }}>Please click on each item below to view and agree to the document</span>
                                        <ul className="pt-2" style={{ paddingLeft: "10px" }}>
                                            <li style={{ color: '#EE7623', cursor: 'pointer' }} onClick={() => this.setState({ dialog: { open: true, type: 'importantNotes' } })}>1. Important Notes</li>
                                            <li style={{ color: '#EE7623', cursor: 'pointer' }} onClick={() => this.setState({ dialog: { open: true, type: 'termsAndConditions' } })}>2. Terms and Conditions and Direct Credit Instruction</li>
                                            {/* <li style={{ color: '#EE7623', cursor: 'pointer' }} onClick={() => this.setState({ dialog: { open: true, type: 'fatcaAndCrs' } })}>3. FATCA and CRS Declarations</li> */}
                                            <li style={{ color: '#EE7623', cursor: 'pointer' }} onClick={() => this.setState({ dialog: { open: true, type: 'personalDataProtection' } })}>3. Personal Data Protection Notice</li>
                                            <li style={{ color: '#EE7623', cursor: 'pointer' }} onClick={() => this.handleViewDeclaration()}>4. Person to be Covered's Declaration</li>
                                            {this.state.isASMB && <li style={{ color: '#EE7623', cursor: 'pointer' }} onClick={() => this.setState({ dialog: { open: true, type: 'customerDeclaration' } })}>5. Customer Declaration</li>}
                                        </ul>
                                    </Checkbox>
                                    <Checkbox
                                        onChange={(e) => this.handleAgreementChecked('agreeCollectData', e.target.checked)}
                                        checked={this.state.agreement.agreeCollectData}
                                    >
                                        I agree that any personal information collected or held by FWD Takaful (whether contained in this application form or otherwise obtained) may be used by FWD Takaful or disclosed by FWD Takaful to third parties for the purposes of direct marketing and to communicate with me for such purposes.
                                    </Checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.showMessageModal()}
                </div>
                <AppModal
                    open={this.state.dialog.open}
                    handlePositivePress={() => this.setState({ dialog: { open: false, type: '' } })}
                    closable={false}
                >
                    <div className="quotation_privacy_policy_container d-flex">
                        <span className="quotation_privacy_policy_title">
                            {(
                                this.state.dialog.type === "importantNotes" ? "Important Notes" :
                                    this.state.dialog.type === "termsAndConditions" ? "Terms and Conditions and Direct Credit Instruction" :
                                        this.state.dialog.type === "fatcaAndCrs" ? "FATCA and CRS Declarations" :
                                            this.state.dialog.type === "personalDataProtection" ? "Personal Data Protection Notice" :
                                                this.state.dialog.type === "customerDeclaration" ? "Customer Declaration" : ''
                            ).toLocaleUpperCase()}</span>
                    </div>
                    {this.renderDialogContent()}
                    <div className="column mt-3 d-flex justify-content-end">
                        <Button
                            type='text'
                            style={{
                                color: '#FFFFFF',
                                backgroundColor: this.renderDisabled() ? '#183028' : '#A3ACA9',
                                fontSize: 14,
                                fontWeight: '600',
                                width: 170,
                                height: 40,
                                borderRadius: 0
                            }}
                            className="d-flex align-items-center justify-content-center"
                            onClick={() => this.setState({ dialog: { open: false, type: '' } })}
                            disabled={!this.renderDisabled()}
                        >
                            Ok
                        </Button>
                    </div>
                </AppModal>
            </div>
        );
    }

    getLastUrlParam = () => {
        const url = window.location.href;
        const params = url.split("/");
        return params[params.length - 1];
    };
}

const mapStateToProps = (state) => ({
});

export default withRouter(connect(mapStateToProps)(ReviewDeclaration));
